module.exports = __webpack_public_path__ + "img/组-643@2x.d229839a.webp";